import React from "react";

import { SelectField } from "./fields";

// Hook-free: pages call this as a plain function too.
const SelectRenderer = ({ styles, ...props }) => <SelectField {...props} />;

export default SelectRenderer;
